<style lang="scss" scoped>
  	.past-new {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	@media (min-width:800px) {
		.past-new {
			background: url('../../assets/past/pass-bg-pc.png') no-repeat center;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.contianer {
			position: relative;
			width: 742px;
			height: 742px;
		}
		.background {
			position: absolute;
			top: 0;
			left: 0;
			width: 742px;
			height: 742px;
			text-align: center;
			animation:animation1 40s linear infinite;
			// background: url('../../assets/past/circle-bg.png');
			// padding-top: 89px;
		}
		@keyframes animation1 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.contianer .content {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 100%;
			text-align: center;
			cursor: pointer;
			padding-top: 40%;
			.word1 {
				position: relative;
				display: inline-block;
				padding-left: 10px;
				padding-right: 10px;
				color: #b74669;
				font-weight: bold;
				margin-bottom: 10px;
				.word-bg1 {
					position: absolute;
					top: 0;
					left: 0;
				}
				.word-bg2 {
					position: absolute;
					right: 0;
					bottom: 0;
				}
			}
			.word2 {
				font-weight: bold;
				font-size: 22px;
				color: #bc7566;
			}
		}
		.contianer .content .step-word-other {
			position: absolute;
			top: 87px;
			left: 0;
		}
		.step1-size {
			font-size: 36px;
		}
		.step3-size-other {
			font-size: 30px;
		}
		.step6-size {
			font-size: 20px;
		}
		.image-list1 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.image-list2 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.image-list3 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			// position: absolute;
			// top: 200px;
			// left: -210px;
			// width: 1200px;
			// height: 500px;
			// .image-item {
			// 	position: absolute;
			// 	&:nth-child(1) {top: 0; left: 0;}
			// 	&:nth-child(2) {top: 0; left: 375px;}
			// 	&:nth-child(3) {top: 0; left: 735px;}
			// 	&:nth-child(4) {top: 75px; left: 30px;}
			// 	&:nth-child(5) {top: 75px; left: 405px;}
			// 	&:nth-child(6) {top: 75px; left: 765px;}
			// }
		}
		.image-list4 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
	}
	@media (max-width:800px) {
		.past-new {
			background: url('../../assets/past/pass-bg-mobile.png') no-repeat center;
			background-size: 100% 100%;
			padding-top: 20vh;
		}
		.contianer {
			position: relative;
			// width: 76vh;
			// height: 76vh;
			//overflow: hidden;
		}
		.background {
			width: 100%;
			height: 100%;
			animation:animation1 40s linear infinite;
			// position: absolute;
			// background: url('../../assets/past/circle-bg.png');
			// background-size: 100% 100%;
		}
		@keyframes animation1 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.contianer .content {
			position: absolute;
			top: 0;
			bottom: 0;
			width: 100%;
			text-align: center;
			cursor: pointer;
			padding-top: 40%;
			.word1 {
				position: relative;
				display: inline-block;
				padding-left: 10px;
				padding-right: 10px;
				color: #b74669;
				font-weight: bold;
				margin-bottom: 10px;
				padding-top: 2px;
				padding-bottom: 2px;
				.word-bg1 {
					position: absolute;
					top: 0;
					left: 0;
					width: 18px;
				}
				.word-bg2 {
					position: absolute;
					right: 0;
					bottom: 0;
					width: 18px;
				}
			}
			.word2 {
				font-weight: bold;
				font-size: 16px;
				color: #bc7566;
			}
		}
		.contianer .content .step-word-other {
			position: absolute;
			top: 20px;
			left: 0;
			right: 0;
			margin: 0 auto;
		}
		.step1-size {
			font-size: 24px;
		}
		.step3-size-other {
			font-size: 20px;
		}
		.step6-size {
			font-size: 14px;
		}
		.image-list1 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.image-list2 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
		.image-list3 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			// position: absolute;
			// top: 12vh;
			// width: 100%;
			// height: 60vh;
			// .image-item {
			// 	width: 40%;
			// 	position: absolute;
			// 	&:nth-child(1) {top: 0; left: -15%;}
			// 	&:nth-child(2) {top: 0; left: 26%;}
			// 	&:nth-child(3) {top: 0; left: 67%;}
			// 	&:nth-child(4) {top: 10vh; left: -10%;}
			// 	&:nth-child(5) {top: 10vh; left: 31%;}
			// 	&:nth-child(6) {top: 10vh; left: 72%;}
			// }
		}
		.image-list4 {
			position: fixed;
			z-index: 99;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
		}
	}
	.slide-fade-enter-active {
		transition: all 1.5s ease;
	}
	.slide-fade-enter {
		opacity: 0;
	}
</style>

<template>
	<div class="past-new">
		<div class="contianer">
			<img v-show="currentStepNumber=='1'" class="background" src="../../assets/past/circle-bg.png" alt="background">
			<div 
				class="content" 
				@click="goStep" 
			>
				<!-- 第一步 -->
				<transition name="slide-fade">
					<div v-show="currentStepNumber == '1'" class="step1">
						<div class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step1-size">破晓之途</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="word2">可以与我一起启程么？</div>
						</transition>
					</div>
				</transition>
				<!-- 第二步 -->
				<transition name="slide-fade">
					<div v-show="currentStepNumber == '2'" class="step2">
						<div :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>那个时候，一切都只是一个梦想——</span><br>
								<span>2015年10月，半世界之旅终于立项</span>
							</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="image-list1">
								<video 
									style="width: 100%; height: auto;"
									autoplay 
									muted="true" 
									x5-video-player-type='h5' 
									x5-video-player-fullscreen='true' 
									webkit-playsinline 
									playsinline
									:src="step2Video"
								></video>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第三步 -->
				<transition name="slide-fade">
					<div v-show="currentStepNumber == '3'" class="step3">
						<div :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>历经3年，怀着一颗忐忑的心，我们终于出现在大家面前——</span><br>
								<span>2018年7月18日，半世界之旅上线首发</span>
							</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="image-list2">
								<video 
									style="width: 100%; height: auto;"
									autoplay 
									muted="true" 
									x5-video-player-type='h5' 
									x5-video-player-fullscreen='true' 
									webkit-playsinline 
									playsinline
									:src="step3Video"
								></video>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第四步 -->
				<transition name="slide-fade">
					<div v-show="currentStepNumber == '4'" class="step4">
						<div :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>这一年，我们从未停止过脚步——</span><br>
								<span>一直想给大家展示旅途中最美的风景</span>
							</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="image-list3">
								<video 
									style="width: 100%; height: auto;"
									autoplay 
									muted="true" 
									x5-video-player-type='h5' 
									x5-video-player-fullscreen='true' 
									webkit-playsinline 
									playsinline 
									:src="step4Video"
								></video>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第五步 -->
				<transition name="slide-fade">
					<div v-show="currentStepNumber == '5'" class="step5">
						<div v-show="!afterShow" :class="['word1', {'step-word-other': afterShow}]">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step6-size">
								<span>为了你，这个世界终于又变得更好了一点——</span><br>
								<span>我们浴火重生，以全新的姿态来迎接你</span>
							</span>
						</div>
						<transition name="slide-fade">
							<div v-show="afterShow" class="image-list4">
								<video 
									style="width: 100%; height: auto;"
									autoplay 
									muted="true" 
									x5-video-player-type='h5' 
									x5-video-player-fullscreen='true' 
									webkit-playsinline 
									playsinline
									:src="step5Video"
								></video>
							</div>
						</transition>
					</div>
				</transition>
				<!-- 第六步 -->
				<transition name="slide-fade">
					<div v-show="currentStepNumber == '6'" class="step6">
						<div class="word1">
							<img class="word-bg1" src="../../assets/past/word-bg1.png" alt="">
							<img class="word-bg2" src="../../assets/past/word-bg2.png" alt="">
							<span class="step3-size-other">
								<span>现在，曦光破晓，你，</span><br>
								<span>愿与我一同启程，去旅行么？</span>
							</span>
						</div><br>
						<img v-show="type == 1" @click="goAppoint" style="margin-top: 10px;" src="../../assets/past/go-apoint-btn.png" alt="">
						<img v-show="type == 2" @click="goWebsite" style="margin-top: 10px;" src="../../assets/past/go-website-btn.png" alt="">
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'past-new',
	data() {
		return {
			type: 1,
			currentStepNumber: '1',
			interValRoot: null,
			afterShow: false,
			phone: '',
			lixiang: [],
			shoufa: [],
			jingli: [],
			xinneirong: [],
			interValTime: 20000,
			timeOutRoot: null,
			step2Video: 'http://fbbsoc-download.joymore.cn/brotherland/website/past-new-video1-p.mp4',
			step3Video: 'http://fbbsoc-download.joymore.cn/brotherland/website/past-new-video2-p.mp4',
			step4Video: 'http://fbbsoc-download.joymore.cn/brotherland/website/phone-video.mp4',
			step5Video: 'http://fbbsoc-download.joymore.cn/brotherland/website/past-p-video1.mp4'
		}
	},
	watch: {
		currentStepNumber() {
			this.afterShow = false;
			this.showAfter();
		}
	},
	mounted() {
		this.type = this.$route.query.type;

		const width = document.body.clientWidth;
		if(width < 850) {
			this.step2Video = 'http://fbbsoc-download.joymore.cn/brotherland/website/past-new-video1-m.mp4';
			this.step3Video = 'http://fbbsoc-download.joymore.cn/brotherland/website/past-new-video2-m.mp4';
			this.step4Video = 'http://fbbsoc-download.joymore.cn/brotherland/website/past-old-m-video1.mp4';
			this.step5Video = 'http://fbbsoc-download.joymore.cn/brotherland/website/past-m-video1.mp4';
		}
		this.phone = this.$route.query.phone;
		this.initData();
		this.interVal();
		this.showAfter();
	},
	methods: {
		initData() {
			this.$http.get('/api/subscribe/getAccountInfoNew?phone=' + this.phone).then(res => {
				this.lixiang = res.result.lixiang;
				this.xinneirong = res.result.xinneirong;
				this.jingli = res.result.jingli;
				this.shoufa = res.result.shoufa;
			});
		},
		projectApproval(index) {
			return require('../../assets/past/new-project-approval' + (index + 1) + '.png');
		},
		interVal() {
			this.interValRoot = setInterval(() => {
				if(this.currentStepNumber == '6') {
					this.clearInterVal();
				} else {
					this.currentStepNumber = Number(this.currentStepNumber) + 1 + '';
					if(this.currentStepNumber == "2" || this.currentStepNumber == "4" || this.currentStepNumber == "5") {
						this.clearInterVal();
						this.interValTime = 30000;
						this.interVal();
					} else if(this.currentStepNumber == "3") {
						this.clearInterVal();
						this.interValTime = 37000;
						this.interVal();
					} else {
						if(this.interValTime != 20000) {
							this.clearInterVal();
							this.interValTime = 20000;
							this.interVal();
						}
					}
				}
			}, this.interValTime);
		},
		clearInterVal() {
			clearInterval(this.interValRoot);
		},
		showAfter() {
			this.timeOutRoot = setTimeout(() => {
				this.afterShow = true;
				clearTimeout(this.timeOutRoot);
			}, 10000);
		},
		goStep() {
			if(!this.afterShow) {
				clearTimeout(this.timeOutRoot);
				this.afterShow = true;
			} else {
				if(Number(this.currentStepNumber) <= 5) {
					this.currentStepNumber = Number(this.currentStepNumber) + 1 + '';
				}
			}
			this.clearInterVal();
		},
		goAppoint() {
			const width = document.body.clientWidth;
			if(width > 850) {
				this.$router.push({name: 'appoint-home-pc'});
			} else {
				this.$router.push({name: 'appoint-home-mobile'});
			}
		},
		goWebsite() {
			const width = document.body.clientWidth;
			if(width > 850) {
				this.$router.push({name: 'p-index'});
			} else {
				this.$router.push({name: 'm-index'});
			}
		}
	},
	beforeDestroy() {
		this.clearInterVal();
		clearTimeout(this.timeOutRoot);
	}
}
</script>